import { PaginatedResult } from "@/interfaces/common/PaginatedResult";
import { Product } from "@/interfaces/domain/Product";
import { ProductCategory } from "@/interfaces/domain/ProductCategory";
import { api } from "@/services/api";

export type ProductCategoryWithProducts = ProductCategory & { produtos: Product[] };

export async function getCategoryListWithProductsRequest(hallId: string) {
  const { data } = await api.get<ProductCategoryWithProducts[]>(
    `/v2/corredores/${hallId}/categorias/produtos`
  );
  return data;
}

export async function getProductCategoryByIdRequest(id: string) {
  const { data } = await api.get<ProductCategory>(`/categorias/${id}`);
  return data;
}

export async function getCategoryProductListRequest({
  page = 1,
  limit = 10,
  categoryId,
}: {
  page: number;
  limit?: number;
  categoryId: string;
}) {
  const { data } = await api.get<PaginatedResult<Product>>(
    `/v2/categorias/${categoryId}/produtos?page=${page}&limit=${limit}`
  );
  return data;
}
